import InputAdornment from '@material-ui/core/InputAdornment';
import DisabledIcon from '@mui/icons-material/HideSource';
import { CSSProperties } from 'styled-components';

const blockIconForInput = (isDisabled?: boolean, iconStyle?: CSSProperties): JSX.Element | null => {
  return isDisabled ? (
    <InputAdornment position='start'>
      <DisabledIcon style={{ fontSize: 'medium', marginRight: '-20px', ...iconStyle }} />
    </InputAdornment>) : null
}
const blockIconForInputWithOptions = (options: {isDisabled?: boolean, iconStyle?: CSSProperties, inputAdornmentStyle?:CSSProperties }): JSX.Element | null => {
  return options.isDisabled ? (
    <InputAdornment position='start' style={{...options.inputAdornmentStyle}}>
      <DisabledIcon style={{ fontSize: 'medium', marginRight: '-20px', ...options.iconStyle }} />
    </InputAdornment>) : null
}
export { blockIconForInput, blockIconForInputWithOptions }